export const submitFormConstants = {
    SAVE_REQUEST: 'SAVE_REQUEST',
    SAVE_SUCCESS: 'SAVE_SUCCESS',
    SAVE_FAILURE: 'SAVE_FAILURE',

    UPDATE_REQUEST: 'UPDATE_REQUEST',
    UPDATE_SUCCESS: 'UPDATE_SUCCESS',
    UPDATE_FAILURE: 'UPDATE_FAILURE',

    DESTROY_REQUEST: 'DESTROY_REQUEST',
    DESTROY_SUCCESS: 'DESTROY_SUCCESS',
    DESTROY_FAILURE: 'DESTROY_FAILURE',

    EXIST_REQUEST: 'EXIST_REQUEST',
    EXIST_SUCCESS: 'EXIST_SUCCESS',
    EXIST_FAILURE: 'EXIST_FAILURE',
};